module.exports = __webpack_public_path__ + "img/logo-inverted.cf9b16bd.svg";